import { render, staticRenderFns } from "./LotsList.vue?vue&type=template&id=1775da7a&scoped=true&"
import script from "./LotsList.vue?vue&type=script&lang=js&"
export * from "./LotsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1775da7a",
  null
  
)

export default component.exports